<template>
  <v-app>
    <template v-if="isAdminView">
      <AdminSidebar />
      <v-app-bar color="primary" density="compact">
        <v-app-bar-title>System Admin</v-app-bar-title>
        <v-spacer />
        <v-btn variant="text" @click="onLogout">Logout</v-btn>
      </v-app-bar>
      <v-main>
        <router-view />
      </v-main>
    </template>
    <template v-else>
      <ImpersonationBanner />
      <Sidebar />
      <Header />
      <v-main class="grey lighten-1">
        <router-view />
      </v-main>
    </template>

    <Footer />

    <!-- ✅ Global dialog mounted once -->
    <GlobalDialog />

    <!-- Active "new version available" prompt (build behind published) -->
    <UpdateBanner />
  </v-app>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import AdminSidebar from "@/components/AdminSidebar.vue";
import ImpersonationBanner from "@/components/ImpersonationBanner.vue";
import Sidebar from "@/components/Sidebar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import GlobalDialog from "@/components/GlobalDialog.vue";
import UpdateBanner from "@/components/UpdateBanner.vue";

const route = useRoute();
const auth = useAuthStore();

// Admin layout: minimal header when on admin routes (path check is more reliable than meta)
const isAdminView = computed(
  () => route.path.startsWith("/admin") || route.meta.adminOnly === true
);

function onLogout() {
  auth.logout();
}
</script>
